<template>
    <main id="mainCtrl">
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs" v-cloak>
                <li :class="{'active': selectedTab === 'appointments'}" @click.stop.prevent="selectTab('appointments')">
                    <a href="#">Записи</a>
                </li>
                <li :class="{'active': selectedTab === 'clinics'}" @click.stop.prevent="selectTab('clinics')">
                    <a href="#">Клиники</a>
                </li>
            </ul>
        </div>

        <TabClinics v-if="selectedTab === 'clinics'"/>
        <TabAppointments v-if="selectedTab === 'appointments'" :city-options="cityOptions"/>
    </main>
</template>

<script>
import TabClinics from "./TabClinics";
import TabAppointments from "./TabAppointments";

export default {
    components: {
        TabClinics,
        TabAppointments
    },
    props: {
        cityOptions: {
            type: Array,
            required: true
        },
    },
    data: function () {
        return {
            selectedTab: localStorage.getItem('onlineAppointmentsSelectedTab') ?? 'appointments',
        };
    },
    methods: {
        selectTab(newTab) {
            this.selectedTab = newTab;
            localStorage.setItem('onlineAppointmentsSelectedTab', newTab)
        }
    },
}
</script>
